var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37936 9.82757H4.75867V8.37929H8.37936V9.82757ZM8.37936 12H4.75867V13.4483H8.37936V12ZM18.2204 17.0689L15.4469 14.2955C14.8676 14.672 14.1869 14.8965 13.4483 14.8965C11.4497 14.8965 9.82763 13.2745 9.82763 11.2758C9.82763 9.27722 11.4497 7.65515 13.4483 7.65515C15.4469 7.65515 17.069 9.27722 17.069 11.2758C17.069 12.0145 16.8445 12.6952 16.468 13.2672L19.2414 16.0479L18.2204 17.0689ZM15.6207 11.2758C15.6207 10.081 14.6432 9.10343 13.4483 9.10343C12.2535 9.10343 11.2759 10.081 11.2759 11.2758C11.2759 12.4707 12.2535 13.4483 13.4483 13.4483C14.6432 13.4483 15.6207 12.4707 15.6207 11.2758ZM4.75867 17.0689H12V15.6207H4.75867V17.0689Z",
    fill: "#0E0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.446586f5ba92c9688c91c2e0c9b4287a.svg";
export { ForwardRef as ReactComponent };